import React from "react";
import { ToastContainer } from 'react-toastify';
import AppRoutes from './routes/routes';


function App() {
    return (

        <>
            <AppRoutes />
            <ToastContainer zIndex={9999} position="top-center" />
        </>
    );
}
export default App;

